var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.noframe?'noframe':'content'},[_c('keep-alive',[_c(_vm.page,{ref:"page",tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }